var cov_1kfjen4ozy = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Menu/Item.tsx",
      hash = "55a643e2691d64f267e78185e9591eadefdd5aba",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Menu/Item.tsx",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 22
        },
        end: {
          line: 21,
          column: 30
        }
      },
      "1": {
        start: {
          line: 21,
          column: 28
        },
        end: {
          line: 21,
          column: 30
        }
      },
      "2": {
        start: {
          line: 23,
          column: 19
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "3": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 24,
          column: 26
        }
      },
      "4": {
        start: {
          line: 24,
          column: 13
        },
        end: {
          line: 24,
          column: 26
        }
      },
      "5": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 25,
          column: 36
        }
      },
      "6": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 16
        }
      },
      "7": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 44
        }
      },
      "8": {
        start: {
          line: 43,
          column: 16
        },
        end: {
          line: 43,
          column: 34
        }
      },
      "9": {
        start: {
          line: 44,
          column: 40
        },
        end: {
          line: 44,
          column: 48
        }
      },
      "10": {
        start: {
          line: 46,
          column: 53
        },
        end: {
          line: 46,
          column: 94
        }
      },
      "11": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 53,
          column: 5
        }
      },
      "12": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 50
        }
      },
      "13": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 50
        }
      },
      "14": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 52
        }
      },
      "15": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 62
        }
      },
      "16": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 63
        }
      },
      "17": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 48
        }
      },
      "18": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 29
        }
      },
      "19": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 114
        }
      },
      "20": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 32
        }
      },
      "21": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 34
        }
      },
      "22": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 30
        }
      },
      "23": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 66
        }
      },
      "24": {
        start: {
          line: 79,
          column: 39
        },
        end: {
          line: 79,
          column: 41
        }
      },
      "25": {
        start: {
          line: 80,
          column: 82
        },
        end: {
          line: 80,
          column: 92
        }
      },
      "26": {
        start: {
          line: 82,
          column: 16
        },
        end: {
          line: 82,
          column: 23
        }
      },
      "27": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 39
        }
      },
      "28": {
        start: {
          line: 84,
          column: 27
        },
        end: {
          line: 84,
          column: 39
        }
      },
      "29": {
        start: {
          line: 86,
          column: 19
        },
        end: {
          line: 86,
          column: 55
        }
      },
      "30": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 92,
          column: 5
        }
      },
      "31": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 59
        }
      },
      "32": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 58
        }
      },
      "33": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 16
        }
      },
      "34": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 21
        }
      },
      "35": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 100
        }
      },
      "36": {
        start: {
          line: 106,
          column: 21
        },
        end: {
          line: 106,
          column: 52
        }
      },
      "37": {
        start: {
          line: 107,
          column: 24
        },
        end: {
          line: 107,
          column: 89
        }
      },
      "38": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 44
        }
      },
      "39": {
        start: {
          line: 113,
          column: 19
        },
        end: {
          line: 113,
          column: 39
        }
      },
      "40": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 35
        }
      },
      "41": {
        start: {
          line: 118,
          column: 19
        },
        end: {
          line: 118,
          column: 33
        }
      },
      "42": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 29
        }
      },
      "43": {
        start: {
          line: 123,
          column: 47
        },
        end: {
          line: 123,
          column: 57
        }
      },
      "44": {
        start: {
          line: 124,
          column: 16
        },
        end: {
          line: 124,
          column: 29
        }
      },
      "45": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 56
        }
      },
      "46": {
        start: {
          line: 125,
          column: 26
        },
        end: {
          line: 125,
          column: 56
        }
      },
      "47": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 134,
          column: 5
        }
      },
      "48": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 127,
          column: 31
        }
      },
      "49": {
        start: {
          line: 128,
          column: 6
        },
        end: {
          line: 128,
          column: 99
        }
      },
      "50": {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 132,
          column: 24
        }
      },
      "51": {
        start: {
          line: 131,
          column: 8
        },
        end: {
          line: 131,
          column: 34
        }
      },
      "52": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 133,
          column: 32
        }
      },
      "53": {
        start: {
          line: 138,
          column: 85
        },
        end: {
          line: 138,
          column: 95
        }
      },
      "54": {
        start: {
          line: 139,
          column: 24
        },
        end: {
          line: 139,
          column: 85
        }
      },
      "55": {
        start: {
          line: 140,
          column: 22
        },
        end: {
          line: 140,
          column: 54
        }
      },
      "56": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 145,
          column: 5
        }
      },
      "57": {
        start: {
          line: 142,
          column: 27
        },
        end: {
          line: 142,
          column: 64
        }
      },
      "58": {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 143,
          column: 71
        }
      },
      "59": {
        start: {
          line: 143,
          column: 24
        },
        end: {
          line: 143,
          column: 71
        }
      },
      "60": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 49
        }
      },
      "61": {
        start: {
          line: 144,
          column: 43
        },
        end: {
          line: 144,
          column: 49
        }
      },
      "62": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 147,
          column: 29
        }
      },
      "63": {
        start: {
          line: 147,
          column: 23
        },
        end: {
          line: 147,
          column: 29
        }
      },
      "64": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 155,
          column: 5
        }
      },
      "65": {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 149,
          column: 33
        }
      },
      "66": {
        start: {
          line: 150,
          column: 11
        },
        end: {
          line: 155,
          column: 5
        }
      },
      "67": {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 28
        }
      },
      "68": {
        start: {
          line: 156,
          column: 19
        },
        end: {
          line: 156,
          column: 61
        }
      },
      "69": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 57
        }
      },
      "70": {
        start: {
          line: 157,
          column: 17
        },
        end: {
          line: 157,
          column: 57
        }
      },
      "71": {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 161,
          column: 17
        }
      },
      "72": {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 162,
          column: 23
        }
      },
      "73": {
        start: {
          line: 166,
          column: 40
        },
        end: {
          line: 166,
          column: 50
        }
      },
      "74": {
        start: {
          line: 167,
          column: 17
        },
        end: {
          line: 167,
          column: 62
        }
      },
      "75": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 172,
          column: 5
        }
      },
      "76": {
        start: {
          line: 169,
          column: 6
        },
        end: {
          line: 169,
          column: 49
        }
      },
      "77": {
        start: {
          line: 171,
          column: 6
        },
        end: {
          line: 171,
          column: 25
        }
      },
      "78": {
        start: {
          line: 176,
          column: 24
        },
        end: {
          line: 176,
          column: 34
        }
      },
      "79": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 177,
          column: 29
        }
      },
      "80": {
        start: {
          line: 177,
          column: 18
        },
        end: {
          line: 177,
          column: 29
        }
      },
      "81": {
        start: {
          line: 178,
          column: 4
        },
        end: {
          line: 178,
          column: 59
        }
      },
      "82": {
        start: {
          line: 178,
          column: 39
        },
        end: {
          line: 178,
          column: 59
        }
      },
      "83": {
        start: {
          line: 179,
          column: 4
        },
        end: {
          line: 179,
          column: 58
        }
      },
      "84": {
        start: {
          line: 183,
          column: 64
        },
        end: {
          line: 183,
          column: 74
        }
      },
      "85": {
        start: {
          line: 184,
          column: 17
        },
        end: {
          line: 184,
          column: 62
        }
      },
      "86": {
        start: {
          line: 185,
          column: 17
        },
        end: {
          line: 185,
          column: 38
        }
      },
      "87": {
        start: {
          line: 186,
          column: 4
        },
        end: {
          line: 190,
          column: 5
        }
      },
      "88": {
        start: {
          line: 187,
          column: 25
        },
        end: {
          line: 187,
          column: 91
        }
      },
      "89": {
        start: {
          line: 188,
          column: 25
        },
        end: {
          line: 188,
          column: 81
        }
      },
      "90": {
        start: {
          line: 189,
          column: 6
        },
        end: {
          line: 189,
          column: 105
        }
      },
      "91": {
        start: {
          line: 192,
          column: 65
        },
        end: {
          line: 196,
          column: 5
        }
      },
      "92": {
        start: {
          line: 197,
          column: 4
        },
        end: {
          line: 197,
          column: 31
        }
      },
      "93": {
        start: {
          line: 197,
          column: 14
        },
        end: {
          line: 197,
          column: 31
        }
      },
      "94": {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 206,
          column: 5
        }
      },
      "95": {
        start: {
          line: 200,
          column: 6
        },
        end: {
          line: 205,
          column: 7
        }
      },
      "96": {
        start: {
          line: 208,
          column: 4
        },
        end: {
          line: 213,
          column: 5
        }
      },
      "97": {
        start: {
          line: 235,
          column: 8
        },
        end: {
          line: 235,
          column: 18
        }
      },
      "98": {
        start: {
          line: 236,
          column: 52
        },
        end: {
          line: 236,
          column: 62
        }
      },
      "99": {
        start: {
          line: 237,
          column: 36
        },
        end: {
          line: 237,
          column: 40
        }
      },
      "100": {
        start: {
          line: 238,
          column: 21
        },
        end: {
          line: 238,
          column: 36
        }
      },
      "101": {
        start: {
          line: 240,
          column: 23
        },
        end: {
          line: 240,
          column: 81
        }
      },
      "102": {
        start: {
          line: 242,
          column: 15
        },
        end: {
          line: 242,
          column: 20
        }
      },
      "103": {
        start: {
          line: 243,
          column: 4
        },
        end: {
          line: 245,
          column: 5
        }
      },
      "104": {
        start: {
          line: 244,
          column: 6
        },
        end: {
          line: 244,
          column: 98
        }
      },
      "105": {
        start: {
          line: 247,
          column: 22
        },
        end: {
          line: 247,
          column: 84
        }
      },
      "106": {
        start: {
          line: 249,
          column: 22
        },
        end: {
          line: 260,
          column: 5
        }
      },
      "107": {
        start: {
          line: 262,
          column: 18
        },
        end: {
          line: 262,
          column: 37
        }
      },
      "108": {
        start: {
          line: 266,
          column: 8
        },
        end: {
          line: 266,
          column: 10
        }
      },
      "109": {
        start: {
          line: 267,
          column: 4
        },
        end: {
          line: 270,
          column: 5
        }
      },
      "110": {
        start: {
          line: 268,
          column: 6
        },
        end: {
          line: 268,
          column: 49
        }
      },
      "111": {
        start: {
          line: 269,
          column: 6
        },
        end: {
          line: 269,
          column: 49
        }
      },
      "112": {
        start: {
          line: 271,
          column: 4
        },
        end: {
          line: 296,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 21,
            column: 22
          },
          end: {
            line: 21,
            column: 23
          }
        },
        loc: {
          start: {
            line: 21,
            column: 28
          },
          end: {
            line: 21,
            column: 30
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 23,
            column: 19
          },
          end: {
            line: 23,
            column: 20
          }
        },
        loc: {
          start: {
            line: 23,
            column: 66
          },
          end: {
            line: 26,
            column: 1
          }
        },
        line: 23
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        loc: {
          start: {
            line: 39,
            column: 35
          },
          end: {
            line: 61,
            column: 3
          }
        },
        line: 39
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 44,
            column: 40
          },
          end: {
            line: 44,
            column: 41
          }
        },
        loc: {
          start: {
            line: 44,
            column: 46
          },
          end: {
            line: 44,
            column: 48
          }
        },
        line: 44
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 63,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        },
        loc: {
          start: {
            line: 63,
            column: 22
          },
          end: {
            line: 66,
            column: 3
          }
        },
        line: 63
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        loc: {
          start: {
            line: 68,
            column: 25
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 68
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 74,
            column: 3
          }
        },
        loc: {
          start: {
            line: 74,
            column: 29
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 74
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        },
        loc: {
          start: {
            line: 78,
            column: 17
          },
          end: {
            line: 95,
            column: 3
          }
        },
        line: 78
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 97,
            column: 3
          }
        },
        loc: {
          start: {
            line: 97,
            column: 33
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 97
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        },
        loc: {
          start: {
            line: 101,
            column: 24
          },
          end: {
            line: 103,
            column: 3
          }
        },
        line: 101
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 105,
            column: 2
          },
          end: {
            line: 105,
            column: 3
          }
        },
        loc: {
          start: {
            line: 105,
            column: 70
          },
          end: {
            line: 110,
            column: 3
          }
        },
        line: 105
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 112,
            column: 2
          },
          end: {
            line: 112,
            column: 3
          }
        },
        loc: {
          start: {
            line: 112,
            column: 46
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 112
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 117,
            column: 2
          },
          end: {
            line: 117,
            column: 3
          }
        },
        loc: {
          start: {
            line: 117,
            column: 49
          },
          end: {
            line: 120,
            column: 3
          }
        },
        line: 117
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 122,
            column: 2
          },
          end: {
            line: 122,
            column: 3
          }
        },
        loc: {
          start: {
            line: 122,
            column: 30
          },
          end: {
            line: 135,
            column: 3
          }
        },
        line: 122
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 130,
            column: 36
          },
          end: {
            line: 130,
            column: 37
          }
        },
        loc: {
          start: {
            line: 130,
            column: 42
          },
          end: {
            line: 132,
            column: 7
          }
        },
        line: 130
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 137,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        },
        loc: {
          start: {
            line: 137,
            column: 35
          },
          end: {
            line: 158,
            column: 3
          }
        },
        line: 137
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 160,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        },
        loc: {
          start: {
            line: 160,
            column: 62
          },
          end: {
            line: 163,
            column: 3
          }
        },
        line: 160
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 165,
            column: 2
          },
          end: {
            line: 165,
            column: 3
          }
        },
        loc: {
          start: {
            line: 165,
            column: 36
          },
          end: {
            line: 173,
            column: 3
          }
        },
        line: 165
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 175,
            column: 3
          }
        },
        loc: {
          start: {
            line: 175,
            column: 22
          },
          end: {
            line: 180,
            column: 3
          }
        },
        line: 175
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 182,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        },
        loc: {
          start: {
            line: 182,
            column: 60
          },
          end: {
            line: 214,
            column: 3
          }
        },
        line: 182
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 216,
            column: 2
          },
          end: {
            line: 216,
            column: 3
          }
        },
        loc: {
          start: {
            line: 216,
            column: 11
          },
          end: {
            line: 297,
            column: 3
          }
        },
        line: 216
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 26
          }
        }, {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 26
          }
        }],
        line: 24
      },
      "1": {
        loc: {
          start: {
            line: 74,
            column: 9
          },
          end: {
            line: 74,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 74,
            column: 17
          },
          end: {
            line: 74,
            column: 27
          }
        }],
        line: 74
      },
      "2": {
        loc: {
          start: {
            line: 80,
            column: 31
          },
          end: {
            line: 80,
            column: 71
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 80,
            column: 46
          },
          end: {
            line: 80,
            column: 71
          }
        }],
        line: 80
      },
      "3": {
        loc: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 39
          }
        }, {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 39
          }
        }],
        line: 84
      },
      "4": {
        loc: {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        }, {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        }],
        line: 88
      },
      "5": {
        loc: {
          start: {
            line: 107,
            column: 24
          },
          end: {
            line: 107,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 107,
            column: 49
          },
          end: {
            line: 107,
            column: 81
          }
        }, {
          start: {
            line: 107,
            column: 84
          },
          end: {
            line: 107,
            column: 89
          }
        }],
        line: 107
      },
      "6": {
        loc: {
          start: {
            line: 107,
            column: 24
          },
          end: {
            line: 107,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 24
          },
          end: {
            line: 107,
            column: 34
          }
        }, {
          start: {
            line: 107,
            column: 38
          },
          end: {
            line: 107,
            column: 46
          }
        }],
        line: 107
      },
      "7": {
        loc: {
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 56
          }
        }, {
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 56
          }
        }],
        line: 125
      },
      "8": {
        loc: {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 134,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 134,
            column: 5
          }
        }, {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 134,
            column: 5
          }
        }],
        line: 126
      },
      "9": {
        loc: {
          start: {
            line: 140,
            column: 22
          },
          end: {
            line: 140,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 140,
            column: 22
          },
          end: {
            line: 140,
            column: 39
          }
        }, {
          start: {
            line: 140,
            column: 43
          },
          end: {
            line: 140,
            column: 54
          }
        }],
        line: 140
      },
      "10": {
        loc: {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }, {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }],
        line: 141
      },
      "11": {
        loc: {
          start: {
            line: 141,
            column: 8
          },
          end: {
            line: 141,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 141,
            column: 8
          },
          end: {
            line: 141,
            column: 25
          }
        }, {
          start: {
            line: 141,
            column: 29
          },
          end: {
            line: 141,
            column: 42
          }
        }, {
          start: {
            line: 141,
            column: 46
          },
          end: {
            line: 141,
            column: 55
          }
        }],
        line: 141
      },
      "12": {
        loc: {
          start: {
            line: 142,
            column: 27
          },
          end: {
            line: 142,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 27
          },
          end: {
            line: 142,
            column: 40
          }
        }, {
          start: {
            line: 142,
            column: 44
          },
          end: {
            line: 142,
            column: 64
          }
        }],
        line: 142
      },
      "13": {
        loc: {
          start: {
            line: 143,
            column: 6
          },
          end: {
            line: 143,
            column: 71
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 143,
            column: 6
          },
          end: {
            line: 143,
            column: 71
          }
        }, {
          start: {
            line: 143,
            column: 6
          },
          end: {
            line: 143,
            column: 71
          }
        }],
        line: 143
      },
      "14": {
        loc: {
          start: {
            line: 144,
            column: 6
          },
          end: {
            line: 144,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 6
          },
          end: {
            line: 144,
            column: 49
          }
        }, {
          start: {
            line: 144,
            column: 6
          },
          end: {
            line: 144,
            column: 49
          }
        }],
        line: 144
      },
      "15": {
        loc: {
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 144,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 144,
            column: 26
          }
        }, {
          start: {
            line: 144,
            column: 30
          },
          end: {
            line: 144,
            column: 41
          }
        }],
        line: 144
      },
      "16": {
        loc: {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 29
          }
        }, {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 29
          }
        }],
        line: 147
      },
      "17": {
        loc: {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        }, {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        }],
        line: 148
      },
      "18": {
        loc: {
          start: {
            line: 150,
            column: 11
          },
          end: {
            line: 155,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 150,
            column: 11
          },
          end: {
            line: 155,
            column: 5
          }
        }, {
          start: {
            line: 150,
            column: 11
          },
          end: {
            line: 155,
            column: 5
          }
        }],
        line: 150
      },
      "19": {
        loc: {
          start: {
            line: 151,
            column: 6
          },
          end: {
            line: 152,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 151,
            column: 7
          },
          end: {
            line: 151,
            column: 21
          }
        }, {
          start: {
            line: 151,
            column: 25
          },
          end: {
            line: 151,
            column: 51
          }
        }, {
          start: {
            line: 151,
            column: 55
          },
          end: {
            line: 151,
            column: 76
          }
        }, {
          start: {
            line: 151,
            column: 80
          },
          end: {
            line: 151,
            column: 96
          }
        }, {
          start: {
            line: 152,
            column: 6
          },
          end: {
            line: 152,
            column: 35
          }
        }],
        line: 151
      },
      "20": {
        loc: {
          start: {
            line: 156,
            column: 20
          },
          end: {
            line: 156,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 156,
            column: 20
          },
          end: {
            line: 156,
            column: 41
          }
        }, {
          start: {
            line: 156,
            column: 45
          },
          end: {
            line: 156,
            column: 47
          }
        }],
        line: 156
      },
      "21": {
        loc: {
          start: {
            line: 156,
            column: 21
          },
          end: {
            line: 156,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 156,
            column: 21
          },
          end: {
            line: 156,
            column: 25
          }
        }, {
          start: {
            line: 156,
            column: 29
          },
          end: {
            line: 156,
            column: 31
          }
        }],
        line: 156
      },
      "22": {
        loc: {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 57
          }
        }, {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 57
          }
        }],
        line: 157
      },
      "23": {
        loc: {
          start: {
            line: 168,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 168,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        }, {
          start: {
            line: 168,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        }],
        line: 168
      },
      "24": {
        loc: {
          start: {
            line: 168,
            column: 8
          },
          end: {
            line: 168,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 168,
            column: 8
          },
          end: {
            line: 168,
            column: 18
          }
        }, {
          start: {
            line: 168,
            column: 22
          },
          end: {
            line: 168,
            column: 40
          }
        }],
        line: 168
      },
      "25": {
        loc: {
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 177,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 177,
            column: 29
          }
        }, {
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 177,
            column: 29
          }
        }],
        line: 177
      },
      "26": {
        loc: {
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 178,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 178,
            column: 59
          }
        }, {
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 178,
            column: 59
          }
        }],
        line: 178
      },
      "27": {
        loc: {
          start: {
            line: 182,
            column: 13
          },
          end: {
            line: 182,
            column: 30
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 182,
            column: 25
          },
          end: {
            line: 182,
            column: 30
          }
        }],
        line: 182
      },
      "28": {
        loc: {
          start: {
            line: 186,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 186,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        }, {
          start: {
            line: 186,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        }],
        line: 186
      },
      "29": {
        loc: {
          start: {
            line: 187,
            column: 56
          },
          end: {
            line: 187,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 187,
            column: 56
          },
          end: {
            line: 187,
            column: 66
          }
        }, {
          start: {
            line: 187,
            column: 70
          },
          end: {
            line: 187,
            column: 90
          }
        }],
        line: 187
      },
      "30": {
        loc: {
          start: {
            line: 188,
            column: 50
          },
          end: {
            line: 188,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 188,
            column: 50
          },
          end: {
            line: 188,
            column: 60
          }
        }, {
          start: {
            line: 188,
            column: 64
          },
          end: {
            line: 188,
            column: 80
          }
        }],
        line: 188
      },
      "31": {
        loc: {
          start: {
            line: 197,
            column: 4
          },
          end: {
            line: 197,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 197,
            column: 4
          },
          end: {
            line: 197,
            column: 31
          }
        }, {
          start: {
            line: 197,
            column: 4
          },
          end: {
            line: 197,
            column: 31
          }
        }],
        line: 197
      },
      "32": {
        loc: {
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 206,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 206,
            column: 5
          }
        }, {
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 206,
            column: 5
          }
        }],
        line: 199
      },
      "33": {
        loc: {
          start: {
            line: 202,
            column: 75
          },
          end: {
            line: 202,
            column: 100
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 202,
            column: 75
          },
          end: {
            line: 202,
            column: 84
          }
        }, {
          start: {
            line: 202,
            column: 88
          },
          end: {
            line: 202,
            column: 100
          }
        }],
        line: 202
      },
      "34": {
        loc: {
          start: {
            line: 238,
            column: 21
          },
          end: {
            line: 238,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 238,
            column: 21
          },
          end: {
            line: 238,
            column: 30
          }
        }, {
          start: {
            line: 238,
            column: 34
          },
          end: {
            line: 238,
            column: 36
          }
        }],
        line: 238
      },
      "35": {
        loc: {
          start: {
            line: 240,
            column: 23
          },
          end: {
            line: 240,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 240,
            column: 56
          },
          end: {
            line: 240,
            column: 70
          }
        }, {
          start: {
            line: 240,
            column: 73
          },
          end: {
            line: 240,
            column: 81
          }
        }],
        line: 240
      },
      "36": {
        loc: {
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 245,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 245,
            column: 5
          }
        }, {
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 245,
            column: 5
          }
        }],
        line: 243
      },
      "37": {
        loc: {
          start: {
            line: 243,
            column: 8
          },
          end: {
            line: 243,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 243,
            column: 8
          },
          end: {
            line: 243,
            column: 32
          }
        }, {
          start: {
            line: 243,
            column: 36
          },
          end: {
            line: 243,
            column: 48
          }
        }],
        line: 243
      },
      "38": {
        loc: {
          start: {
            line: 247,
            column: 22
          },
          end: {
            line: 247,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 247,
            column: 38
          },
          end: {
            line: 247,
            column: 62
          }
        }, {
          start: {
            line: 247,
            column: 65
          },
          end: {
            line: 247,
            column: 84
          }
        }],
        line: 247
      },
      "39": {
        loc: {
          start: {
            line: 251,
            column: 6
          },
          end: {
            line: 251,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 251,
            column: 6
          },
          end: {
            line: 251,
            column: 25
          }
        }, {
          start: {
            line: 251,
            column: 29
          },
          end: {
            line: 251,
            column: 39
          }
        }],
        line: 251
      },
      "40": {
        loc: {
          start: {
            line: 252,
            column: 6
          },
          end: {
            line: 252,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 252,
            column: 18
          },
          end: {
            line: 252,
            column: 32
          }
        }, {
          start: {
            line: 252,
            column: 35
          },
          end: {
            line: 252,
            column: 48
          }
        }],
        line: 252
      },
      "41": {
        loc: {
          start: {
            line: 253,
            column: 6
          },
          end: {
            line: 253,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 253,
            column: 6
          },
          end: {
            line: 253,
            column: 14
          }
        }, {
          start: {
            line: 253,
            column: 18
          },
          end: {
            line: 253,
            column: 26
          }
        }],
        line: 253
      },
      "42": {
        loc: {
          start: {
            line: 254,
            column: 6
          },
          end: {
            line: 254,
            column: 20
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 254,
            column: 6
          },
          end: {
            line: 254,
            column: 10
          }
        }, {
          start: {
            line: 254,
            column: 14
          },
          end: {
            line: 254,
            column: 20
          }
        }],
        line: 254
      },
      "43": {
        loc: {
          start: {
            line: 255,
            column: 6
          },
          end: {
            line: 255,
            column: 23
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 255,
            column: 6
          },
          end: {
            line: 255,
            column: 10
          }
        }, {
          start: {
            line: 255,
            column: 14
          },
          end: {
            line: 255,
            column: 23
          }
        }],
        line: 255
      },
      "44": {
        loc: {
          start: {
            line: 256,
            column: 6
          },
          end: {
            line: 256,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 256,
            column: 6
          },
          end: {
            line: 256,
            column: 17
          }
        }, {
          start: {
            line: 256,
            column: 21
          },
          end: {
            line: 256,
            column: 32
          }
        }],
        line: 256
      },
      "45": {
        loc: {
          start: {
            line: 257,
            column: 6
          },
          end: {
            line: 257,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 257,
            column: 6
          },
          end: {
            line: 257,
            column: 12
          }
        }, {
          start: {
            line: 257,
            column: 16
          },
          end: {
            line: 257,
            column: 25
          }
        }],
        line: 257
      },
      "46": {
        loc: {
          start: {
            line: 258,
            column: 6
          },
          end: {
            line: 258,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 258,
            column: 6
          },
          end: {
            line: 258,
            column: 16
          }
        }, {
          start: {
            line: 258,
            column: 20
          },
          end: {
            line: 258,
            column: 45
          }
        }],
        line: 258
      },
      "47": {
        loc: {
          start: {
            line: 259,
            column: 6
          },
          end: {
            line: 259,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 259,
            column: 6
          },
          end: {
            line: 259,
            column: 22
          }
        }, {
          start: {
            line: 259,
            column: 26
          },
          end: {
            line: 259,
            column: 38
          }
        }],
        line: 259
      },
      "48": {
        loc: {
          start: {
            line: 267,
            column: 4
          },
          end: {
            line: 270,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 267,
            column: 4
          },
          end: {
            line: 270,
            column: 5
          }
        }, {
          start: {
            line: 267,
            column: 4
          },
          end: {
            line: 270,
            column: 5
          }
        }],
        line: 267
      },
      "49": {
        loc: {
          start: {
            line: 274,
            column: 9
          },
          end: {
            line: 294,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 274,
            column: 9
          },
          end: {
            line: 274,
            column: 18
          }
        }, {
          start: {
            line: 275,
            column: 10
          },
          end: {
            line: 293,
            column: 12
          }
        }],
        line: 274
      },
      "50": {
        loc: {
          start: {
            line: 281,
            column: 26
          },
          end: {
            line: 281,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 281,
            column: 50
          },
          end: {
            line: 281,
            column: 51
          }
        }, {
          start: {
            line: 281,
            column: 54
          },
          end: {
            line: 281,
            column: 66
          }
        }],
        line: 281
      },
      "51": {
        loc: {
          start: {
            line: 282,
            column: 18
          },
          end: {
            line: 282,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 282,
            column: 42
          },
          end: {
            line: 282,
            column: 50
          }
        }, {
          start: {
            line: 282,
            column: 53
          },
          end: {
            line: 282,
            column: 57
          }
        }],
        line: 282
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    b: {
      "0": [0, 0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0, 0, 0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Menu/Item.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { cloneElement } from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { getKey as _getKey, getUidStr } from '../utils/uid';
import { menuClass } from './styles';
import List from './List';
import { consumer } from './context';
import { isLink } from '../utils/is';
import { isRTL } from '../config';
import { getParent, wrapSpan } from '../utils/dom/element';
import { DefaultProps } from './Root';
cov_1kfjen4ozy.s[0]++;

var getBaseIndent = function getBaseIndent() {
  cov_1kfjen4ozy.f[0]++;
  cov_1kfjen4ozy.s[1]++;
  return 16;
};

cov_1kfjen4ozy.s[2]++;

var calcIndent = function calcIndent(flag, indent) {
  cov_1kfjen4ozy.f[1]++;
  cov_1kfjen4ozy.s[3]++;

  if (!flag) {
    cov_1kfjen4ozy.b[0][0]++;
    cov_1kfjen4ozy.s[4]++;
    return indent;
  } else {
    cov_1kfjen4ozy.b[0][1]++;
  }

  cov_1kfjen4ozy.s[5]++;
  return Math.ceil(indent / 3 * 2);
};

var Item =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Item, _PureComponent);

  var _super = _createSuper2(Item);

  function Item(props) {
    var _this;

    _classCallCheck(this, Item);

    cov_1kfjen4ozy.f[2]++;
    cov_1kfjen4ozy.s[6]++;
    _this = _super.call(this, props);
    _this.id = void 0;
    _this.handleMouseEnter = void 0;
    _this.handleMouseLeave = void 0;
    _this.element = void 0;
    _this.toggleTimer = void 0;
    cov_1kfjen4ozy.s[7]++;
    _this.id = "".concat(props.path, ",").concat(getUidStr());
    var key = (cov_1kfjen4ozy.s[8]++, _this.getKey(props));
    cov_1kfjen4ozy.s[9]++;

    var noop = function noop() {
      cov_1kfjen4ozy.f[3]++;
    };

    var _ref = (cov_1kfjen4ozy.s[10]++, props.bindItem(_this.id, noop, noop, noop)),
        _ref2 = _slicedToArray(_ref, 3),
        activeUpdate = _ref2[0],
        openUpdate = _ref2[1],
        inPathUpdate = _ref2[2];

    cov_1kfjen4ozy.s[11]++;
    _this.state = {
      open: openUpdate(key),
      isActive: activeUpdate(_this.id, props.data),
      inPath: inPathUpdate(_this.id),
      isHighLight: false
    };
    cov_1kfjen4ozy.s[12]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_1kfjen4ozy.s[13]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    cov_1kfjen4ozy.s[14]++;
    _this.handleSwitch = _this.handleSwitch.bind(_assertThisInitialized(_this));
    cov_1kfjen4ozy.s[15]++;
    _this.handleMouseEnter = _this.handleToggle.bind(_assertThisInitialized(_this), true);
    cov_1kfjen4ozy.s[16]++;
    _this.handleMouseLeave = _this.handleToggle.bind(_assertThisInitialized(_this), false);
    cov_1kfjen4ozy.s[17]++;
    _this.renderLink = _this.renderLink.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Item, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1kfjen4ozy.f[4]++;
      cov_1kfjen4ozy.s[18]++;

      _get(_getPrototypeOf(Item.prototype), "componentDidMount", this).call(this);

      cov_1kfjen4ozy.s[19]++;
      this.props.bindItem(this.id, this.update.bind(this), this.updateOpen.bind(this), this.updateInPath.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1kfjen4ozy.f[5]++;
      cov_1kfjen4ozy.s[20]++;

      _get(_getPrototypeOf(Item.prototype), "componentWillUnmount", this).call(this);

      cov_1kfjen4ozy.s[21]++;
      this.props.unbindItem(this.id);
      cov_1kfjen4ozy.s[22]++;
      this.unbindDocumentEvent();
    }
  }, {
    key: "getKey",
    value: function getKey() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1kfjen4ozy.b[1][0]++, this.props);
      cov_1kfjen4ozy.f[6]++;
      cov_1kfjen4ozy.s[23]++;
      return _getKey(props.data, props.keygen, props.index);
    }
  }, {
    key: "getCalcStyle",
    value: function getCalcStyle() {
      cov_1kfjen4ozy.f[7]++;
      var style = (cov_1kfjen4ozy.s[24]++, {});

      var _ref3 = (cov_1kfjen4ozy.s[25]++, this.props),
          frontCaret = _ref3.frontCaret,
          level = _ref3.level,
          _ref3$inlineIndent = _ref3.inlineIndent,
          inlineIndent = _ref3$inlineIndent === void 0 ? (cov_1kfjen4ozy.b[2][0]++, DefaultProps.inlineIndent) : _ref3$inlineIndent,
          mode = _ref3.mode;

      var rtl = (cov_1kfjen4ozy.s[26]++, isRTL());
      cov_1kfjen4ozy.s[27]++;

      if (mode !== 'inline') {
        cov_1kfjen4ozy.b[3][0]++;
        cov_1kfjen4ozy.s[28]++;
        return style;
      } else {
        cov_1kfjen4ozy.b[3][1]++;
      }

      var indent = (cov_1kfjen4ozy.s[29]++, calcIndent(frontCaret, inlineIndent));
      cov_1kfjen4ozy.s[30]++;

      if (rtl) {
        cov_1kfjen4ozy.b[4][0]++;
        cov_1kfjen4ozy.s[31]++;
        style.paddingRight = getBaseIndent() + level * indent;
      } else {
        cov_1kfjen4ozy.b[4][1]++;
        cov_1kfjen4ozy.s[32]++;
        style.paddingLeft = getBaseIndent() + level * indent;
      }

      cov_1kfjen4ozy.s[33]++;
      return style;
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_1kfjen4ozy.f[8]++;
      cov_1kfjen4ozy.s[34]++;
      this.element = el;
    }
  }, {
    key: "unbindDocumentEvent",
    value: function unbindDocumentEvent() {
      cov_1kfjen4ozy.f[9]++;
      cov_1kfjen4ozy.s[35]++;
      document.removeEventListener('click', this.handleMouseLeave);
    }
  }, {
    key: "update",
    value: function update(check, activePath) {
      cov_1kfjen4ozy.f[10]++;
      var isActive = (cov_1kfjen4ozy.s[36]++, check(this.id, this.props.data));
      var isHighLight = (cov_1kfjen4ozy.s[37]++, (cov_1kfjen4ozy.b[6][0]++, activePath) && (cov_1kfjen4ozy.b[6][1]++, isActive) ? (cov_1kfjen4ozy.b[5][0]++, activePath.indexOf(this.id) > -1) : (cov_1kfjen4ozy.b[5][1]++, false));
      cov_1kfjen4ozy.s[38]++;
      this.setState({
        isActive: isActive,
        isHighLight: isHighLight
      });
    }
  }, {
    key: "updateOpen",
    value: function updateOpen(check) {
      cov_1kfjen4ozy.f[11]++;
      var isOpen = (cov_1kfjen4ozy.s[39]++, check(this.getKey()));
      cov_1kfjen4ozy.s[40]++;
      this.setState({
        open: isOpen
      });
    }
  }, {
    key: "updateInPath",
    value: function updateInPath(check) {
      cov_1kfjen4ozy.f[12]++;
      var inPath = (cov_1kfjen4ozy.s[41]++, check(this.id));
      cov_1kfjen4ozy.s[42]++;
      this.setState({
        inPath: inPath
      });
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(open) {
      cov_1kfjen4ozy.f[13]++;

      var _ref4 = (cov_1kfjen4ozy.s[43]++, this.props),
          toggleOpenKeys = _ref4.toggleOpenKeys,
          toggleDuration = _ref4.toggleDuration;

      var key = (cov_1kfjen4ozy.s[44]++, this.getKey());
      cov_1kfjen4ozy.s[45]++;

      if (this.toggleTimer) {
        cov_1kfjen4ozy.b[7][0]++;
        cov_1kfjen4ozy.s[46]++;
        clearTimeout(this.toggleTimer);
      } else {
        cov_1kfjen4ozy.b[7][1]++;
      }

      cov_1kfjen4ozy.s[47]++;

      if (open) {
        cov_1kfjen4ozy.b[8][0]++;
        cov_1kfjen4ozy.s[48]++;
        toggleOpenKeys(key, true);
        cov_1kfjen4ozy.s[49]++;
        document.addEventListener('click', this.handleMouseLeave);
      } else {
        cov_1kfjen4ozy.b[8][1]++;
        cov_1kfjen4ozy.s[50]++;
        this.toggleTimer = setTimeout(function () {
          cov_1kfjen4ozy.f[14]++;
          cov_1kfjen4ozy.s[51]++;
          toggleOpenKeys(key, false);
        }, toggleDuration);
        cov_1kfjen4ozy.s[52]++;
        this.unbindDocumentEvent();
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      cov_1kfjen4ozy.f[15]++;

      var _ref5 = (cov_1kfjen4ozy.s[53]++, this.props),
          data = _ref5.data,
          onClick = _ref5.onClick,
          mode = _ref5.mode,
          toggleOpenKeys = _ref5.toggleOpenKeys,
          looseChildren = _ref5.looseChildren,
          parentSelectable = _ref5.parentSelectable;

      var expandClick = (cov_1kfjen4ozy.s[54]++, getParent(e.target, ".".concat(menuClass('expand'))));
      var canExpand = (cov_1kfjen4ozy.s[55]++, (cov_1kfjen4ozy.b[9][0]++, !parentSelectable) || (cov_1kfjen4ozy.b[9][1]++, expandClick));
      cov_1kfjen4ozy.s[56]++;

      if ((cov_1kfjen4ozy.b[11][0]++, mode === 'inline') && (cov_1kfjen4ozy.b[11][1]++, data.children) && (cov_1kfjen4ozy.b[11][2]++, canExpand)) {
        cov_1kfjen4ozy.b[10][0]++;
        var shouldToggle = (cov_1kfjen4ozy.s[57]++, (cov_1kfjen4ozy.b[12][0]++, looseChildren) || (cov_1kfjen4ozy.b[12][1]++, data.children.length));
        cov_1kfjen4ozy.s[58]++;

        if (shouldToggle) {
          cov_1kfjen4ozy.b[13][0]++;
          cov_1kfjen4ozy.s[59]++;
          toggleOpenKeys(this.getKey(), !this.state.open);
        } else {
          cov_1kfjen4ozy.b[13][1]++;
        }

        cov_1kfjen4ozy.s[60]++;

        if ((cov_1kfjen4ozy.b[15][0]++, parentSelectable) && (cov_1kfjen4ozy.b[15][1]++, expandClick)) {
          cov_1kfjen4ozy.b[14][0]++;
          cov_1kfjen4ozy.s[61]++;
          return;
        } else {
          cov_1kfjen4ozy.b[14][1]++;
        }
      } else {
        cov_1kfjen4ozy.b[10][1]++;
      }

      cov_1kfjen4ozy.s[62]++;

      if (data.disabled) {
        cov_1kfjen4ozy.b[16][0]++;
        cov_1kfjen4ozy.s[63]++;
        return;
      } else {
        cov_1kfjen4ozy.b[16][1]++;
      }

      cov_1kfjen4ozy.s[64]++;

      if (typeof data.onClick === 'function') {
        cov_1kfjen4ozy.b[17][0]++;
        cov_1kfjen4ozy.s[65]++;
        data.onClick(this.id, data);
      } else {
        cov_1kfjen4ozy.b[17][1]++;
        cov_1kfjen4ozy.s[66]++;

        if (((cov_1kfjen4ozy.b[19][0]++, !data.children) || (cov_1kfjen4ozy.b[19][1]++, data.children.length === 0) || (cov_1kfjen4ozy.b[19][2]++, data.onClick === true) || (cov_1kfjen4ozy.b[19][3]++, parentSelectable)) && (cov_1kfjen4ozy.b[19][4]++, typeof onClick === 'function')) {
          cov_1kfjen4ozy.b[18][0]++;
          cov_1kfjen4ozy.s[67]++;
          onClick(this.id, data);
        } else {
          cov_1kfjen4ozy.b[18][1]++;
        }
      }

      var isLeaf = (cov_1kfjen4ozy.s[68]++, ((cov_1kfjen4ozy.b[20][0]++, ((cov_1kfjen4ozy.b[21][0]++, data) || (cov_1kfjen4ozy.b[21][1]++, {})).children) || (cov_1kfjen4ozy.b[20][1]++, [])).length === 0);
      cov_1kfjen4ozy.s[69]++;

      if (!isLeaf) {
        cov_1kfjen4ozy.b[22][0]++;
        cov_1kfjen4ozy.s[70]++;
        e.nativeEvent.stopImmediatePropagation();
      } else {
        cov_1kfjen4ozy.b[22][1]++;
      }
    }
  }, {
    key: "handleItemClick",
    value: function handleItemClick(clickMethod, e) {
      cov_1kfjen4ozy.f[16]++;
      cov_1kfjen4ozy.s[71]++;
      clickMethod();
      cov_1kfjen4ozy.s[72]++;
      this.handleClick(e);
    }
  }, {
    key: "handleSwitch",
    value: function handleSwitch(e) {
      cov_1kfjen4ozy.f[17]++;

      var _ref6 = (cov_1kfjen4ozy.s[73]++, this.props),
          renderItem = _ref6.renderItem,
          data = _ref6.data,
          index = _ref6.index;

      var item = (cov_1kfjen4ozy.s[74]++, renderItem(data, index));
      cov_1kfjen4ozy.s[75]++;

      if ((cov_1kfjen4ozy.b[24][0]++, item.props) && (cov_1kfjen4ozy.b[24][1]++, item.props.onClick)) {
        cov_1kfjen4ozy.b[23][0]++;
        cov_1kfjen4ozy.s[76]++;
        this.handleItemClick(item.props.onClick, e);
      } else {
        cov_1kfjen4ozy.b[23][1]++;
        cov_1kfjen4ozy.s[77]++;
        this.handleClick(e);
      }
    }
  }, {
    key: "renderLink",
    value: function renderLink(data) {
      cov_1kfjen4ozy.f[18]++;

      var _ref7 = (cov_1kfjen4ozy.s[78]++, this.props),
          linkKey = _ref7.linkKey;

      cov_1kfjen4ozy.s[79]++;

      if (!linkKey) {
        cov_1kfjen4ozy.b[25][0]++;
        cov_1kfjen4ozy.s[80]++;
        return null;
      } else {
        cov_1kfjen4ozy.b[25][1]++;
      }

      cov_1kfjen4ozy.s[81]++;

      if (typeof linkKey === 'function') {
        cov_1kfjen4ozy.b[26][0]++;
        cov_1kfjen4ozy.s[82]++;
        return linkKey(data);
      } else {
        cov_1kfjen4ozy.b[26][1]++;
      }

      cov_1kfjen4ozy.s[83]++;
      return data[linkKey];
    }
  }, {
    key: "renderItem",
    value: function renderItem() {
      var hasChilds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1kfjen4ozy.b[27][0]++, false);
      var style = arguments.length > 1 ? arguments[1] : undefined;
      cov_1kfjen4ozy.f[19]++;

      var _ref8 = (cov_1kfjen4ozy.s[84]++, this.props),
          renderItem = _ref8.renderItem,
          data = _ref8.data,
          index = _ref8.index,
          frontCaret = _ref8.frontCaret,
          caretColor = _ref8.caretColor;

      var item = (cov_1kfjen4ozy.s[85]++, renderItem(data, index));
      var link = (cov_1kfjen4ozy.s[86]++, this.renderLink(data));
      cov_1kfjen4ozy.s[87]++;

      if (isLink(item)) {
        cov_1kfjen4ozy.b[28][0]++;
        var mergeClass = (cov_1kfjen4ozy.s[88]++, classnames(menuClass('title'), (cov_1kfjen4ozy.b[29][0]++, item.props) && (cov_1kfjen4ozy.b[29][1]++, item.props.className)));
        var mergeStyle = (cov_1kfjen4ozy.s[89]++, Object.assign({}, style, (cov_1kfjen4ozy.b[30][0]++, item.props) && (cov_1kfjen4ozy.b[30][1]++, item.props.style)));
        cov_1kfjen4ozy.s[90]++;
        return (
          /*#__PURE__*/
          cloneElement(item, {
            className: mergeClass,
            style: mergeStyle,
            onClick: this.handleSwitch
          })
        );
      } else {
        cov_1kfjen4ozy.b[28][1]++;
      }

      var props = (cov_1kfjen4ozy.s[91]++, {
        className: menuClass('title'),
        style: style,
        onClick: this.handleClick
      });
      cov_1kfjen4ozy.s[92]++;

      if (link) {
        cov_1kfjen4ozy.b[31][0]++;
        cov_1kfjen4ozy.s[93]++;
        props.href = link;
      } else {
        cov_1kfjen4ozy.b[31][1]++;
      }

      cov_1kfjen4ozy.s[94]++;

      if (frontCaret) {
        cov_1kfjen4ozy.b[32][0]++;
        cov_1kfjen4ozy.s[95]++;
        return (
          /*#__PURE__*/
          React.createElement("a", Object.assign({}, props, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 201,
              columnNumber: 9
            }
          }),
          /*#__PURE__*/
          React.createElement("div", {
            style: {
              color: caretColor
            },
            className: menuClass('caret', (cov_1kfjen4ozy.b[33][0]++, hasChilds) && (cov_1kfjen4ozy.b[33][1]++, 'has-childs')),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 202,
              columnNumber: 11
            }
          }), wrapSpan(item))
        );
      } else {
        cov_1kfjen4ozy.b[32][1]++;
      }

      cov_1kfjen4ozy.s[96]++;
      return (
        /*#__PURE__*/
        React.createElement("a", Object.assign({}, props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 209,
            columnNumber: 7
          }
        }), wrapSpan(item),
        /*#__PURE__*/
        React.createElement("span", {
          className: menuClass('expand'),
          style: {
            color: caretColor
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 211,
            columnNumber: 9
          }
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_1kfjen4ozy.f[20]++;

      var _ref9 = (cov_1kfjen4ozy.s[97]++, this.props),
          data = _ref9.data,
          renderItem = _ref9.renderItem,
          mode = _ref9.mode,
          keygen = _ref9.keygen,
          level = _ref9.level,
          onClick = _ref9.onClick,
          inlineIndent = _ref9.inlineIndent,
          disabled = _ref9.disabled,
          toggleOpenKeys = _ref9.toggleOpenKeys,
          bottomLine = _ref9.bottomLine,
          topLine = _ref9.topLine,
          linkKey = _ref9.linkKey,
          toggleDuration = _ref9.toggleDuration,
          frontCaret = _ref9.frontCaret,
          looseChildren = _ref9.looseChildren,
          parentSelectable = _ref9.parentSelectable,
          frontCaretType = _ref9.frontCaretType;

      var _ref10 = (cov_1kfjen4ozy.s[98]++, this.state),
          open = _ref10.open,
          isActive = _ref10.isActive,
          isHighLight = _ref10.isHighLight,
          inPath = _ref10.inPath;

      var _ref11 = (cov_1kfjen4ozy.s[99]++, data),
          dChildren = _ref11.children;

      var children = (cov_1kfjen4ozy.s[100]++, (cov_1kfjen4ozy.b[34][0]++, dChildren) || (cov_1kfjen4ozy.b[34][1]++, []));
      var isDisabled = (cov_1kfjen4ozy.s[101]++, typeof disabled === 'function' ? (cov_1kfjen4ozy.b[35][0]++, disabled(data)) : (cov_1kfjen4ozy.b[35][1]++, disabled));
      var isUp = (cov_1kfjen4ozy.s[102]++, false);
      cov_1kfjen4ozy.s[103]++;

      if ((cov_1kfjen4ozy.b[37][0]++, mode === 'vertical-auto') && (cov_1kfjen4ozy.b[37][1]++, this.element)) {
        cov_1kfjen4ozy.b[36][0]++;
        cov_1kfjen4ozy.s[104]++;
        isUp = this.element.getBoundingClientRect().bottom - topLine > (bottomLine - topLine) / 2;
      } else {
        cov_1kfjen4ozy.b[36][1]++;
      }

      var hasChilds = (cov_1kfjen4ozy.s[105]++, looseChildren ? (cov_1kfjen4ozy.b[38][0]++, Array.isArray(dChildren)) : (cov_1kfjen4ozy.b[38][1]++, children.length > 0));
      var className = (cov_1kfjen4ozy.s[106]++, menuClass('item', (cov_1kfjen4ozy.b[39][0]++, isDisabled === true) && (cov_1kfjen4ozy.b[39][1]++, 'disabled'), hasChilds ? (cov_1kfjen4ozy.b[40][0]++, 'has-children') : (cov_1kfjen4ozy.b[40][1]++, 'no-children'), (cov_1kfjen4ozy.b[41][0]++, isActive) && (cov_1kfjen4ozy.b[41][1]++, 'active'), (cov_1kfjen4ozy.b[42][0]++, open) && (cov_1kfjen4ozy.b[42][1]++, 'open'), (cov_1kfjen4ozy.b[43][0]++, isUp) && (cov_1kfjen4ozy.b[43][1]++, 'open-up'), (cov_1kfjen4ozy.b[44][0]++, isHighLight) && (cov_1kfjen4ozy.b[44][1]++, 'highlight'), (cov_1kfjen4ozy.b[45][0]++, inPath) && (cov_1kfjen4ozy.b[45][1]++, 'in-path'), (cov_1kfjen4ozy.b[46][0]++, frontCaret) && (cov_1kfjen4ozy.b[46][1]++, "caret-".concat(frontCaretType)), (cov_1kfjen4ozy.b[47][0]++, parentSelectable) && (cov_1kfjen4ozy.b[47][1]++, 'selectable')));
      var style = (cov_1kfjen4ozy.s[107]++, this.getCalcStyle());
      var events = (cov_1kfjen4ozy.s[108]++, {});
      cov_1kfjen4ozy.s[109]++;

      if (mode !== 'inline') {
        cov_1kfjen4ozy.b[48][0]++;
        cov_1kfjen4ozy.s[110]++;
        events.onMouseEnter = this.handleMouseEnter;
        cov_1kfjen4ozy.s[111]++;
        events.onMouseLeave = this.handleMouseLeave;
      } else {
        cov_1kfjen4ozy.b[48][1]++;
      }

      cov_1kfjen4ozy.s[112]++;
      return (
        /*#__PURE__*/
        React.createElement("li", Object.assign({
          className: className
        }, events, {
          ref: this.bindElement,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 272,
            columnNumber: 7
          }
        }), this.renderItem(hasChilds, style), (cov_1kfjen4ozy.b[49][0]++, hasChilds) && (cov_1kfjen4ozy.b[49][1]++,
        /*#__PURE__*/
        React.createElement(List // className={menuClass('sub')}
        , {
          data: children,
          disabled: disabled,
          renderItem: renderItem,
          keygen: keygen,
          inlineIndent: mode === 'horizontal' ? (cov_1kfjen4ozy.b[50][0]++, 0) : (cov_1kfjen4ozy.b[50][1]++, inlineIndent),
          mode: mode === 'horizontal' ? (cov_1kfjen4ozy.b[51][0]++, 'inline') : (cov_1kfjen4ozy.b[51][1]++, mode),
          onClick: onClick,
          path: this.id,
          level: level + 1,
          open: open,
          toggleOpenKeys: toggleOpenKeys,
          linkKey: linkKey,
          toggleDuration: toggleDuration,
          frontCaret: frontCaret,
          looseChildren: looseChildren,
          parentSelectable: parentSelectable,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 275,
            columnNumber: 11
          }
        })))
      );
    }
  }]);

  return Item;
}(PureComponent);

export default consumer(Item);